<template>
  <div class="view-sales-recovery">
    <snow-data-table-header
      :datePicker="false"
      :add="false"
      :exportOptions="exportOptions"
      @searching="search"
      @open-filters="filtersModal = true"
    />
    <div class="centralize-row text-center py-7">
      <bp-table-responsive
        ref="BpTableResponsive"
        :pagination-remote-method="onPaginationUpdate"
        paginatorRef="paginator"
        :loading="loading"
        :pagination="pagination"
        :columns="columns"
        :data="initiateCheckout"
      >
        <template #empty>
          <div class="col-lg-12">
            <div class="container centering text-center pt-5">
              <img
                class="d-block mb-5 mx-auto"
                src="@/assets/images/no-content.svg"
              />
              <h5>Você ainda não tem compras para recuperar!</h5>
            </div>
          </div>
        </template>
      </bp-table-responsive>
    </div>

    <responsive-modal
      v-model="filtersModal"
      title="Filtrar"
      description="Selecione os filtros e aplique"
    >
      <sale-recovery-filter
        v-model="filters"
        @close="filtersModal = false"
        @input="() => dispatch()"
      />
    </responsive-modal>
  </div>
</template>
<script>
import copy from "copy-text-to-clipboard";
import moment from "moment";
import { mapState } from "vuex";
import SaleRecoveryFilter from "../../components/sale/SaleRecoveryFilter.vue";
import {
  clearObject,
  formatCnpjCpf,
  formatPhone,
  toHumanDate
} from "../../functions/helpers";

export default {
  components: { SaleRecoveryFilter },
  data() {
    return {
      loading: false,
      exportLoading: false,
      product: "",
      filtersModal: false,
      filters: {
        product_id: "",
        created_at_after: "",
        created_at_before: "",
        search: ""
      },
      params: {
        limit: 20,
        offset: 0
      }
    };
  },
  computed: {
    ...mapState("sale", ["initiateCheckout", "pagination"]),
    ...mapState("product", ["products"]),
    columns() {
      return [
        {
          name: "Data",
          default: "-",
          field: "created_at",
          transform: toHumanDate
        },
        {
          name: "Comprador",
          default: "-",
          field: "shopper_email",
          transform: (_, item) =>
            `<p class="mb-0 pb-0 text-left">
              <span class="fs-14 fw-4 text-neutral-500">${item.name}</span>
              <br/>
              <span class="fs-12 fw-4 text-neutral-400">${item.email}</span>
            </p>`
        },
        {
          name: "Telefone",
          default: "-",
          field: "phone",
          transform: v => formatPhone(v)
        },
        {
          name: "Documento",
          default: "-",
          field: "document",
          transform: v => formatCnpjCpf(v)
        },
        {
          name: "Link do produto",
          default: "-",
          field: "product",
          transform: (v, item) => {
            return `
              <div class="d-flex align-items-center">
                <button
                  class="btn btn-sm btn-transparent btn-square-sm mr-2"
                  onclick="navigator.clipboard.writeText('${this.getLink(
                    item
                  )}')"
                >
                  <i class="text-primary fa-solid fa-copy"></i>
                </button>
                <a
                  class="btn btn-sm btn-transparent btn-square-sm"
                  href=${this.getLink(item)}
                  target="_blank"
                >
                  <i
                    class="text-primary fa-solid fa-arrow-up-right-from-square"
                  ></i>
                </a>
              </div>
            `;
          }
        }
      ];
    },
    exportOptions() {
      return {
        action: "sale/exportInitiateCheckout",
        filters: this.filters,
        filename: "sales_recovery",
        disabled: this.exportLoading || !this.initiateCheckout.length,
        label: "Exportar",
        confirmation: false,
        permission: "exportar-vendas"
      }
    }
  },
  mounted() {
    this.dispatch();
    this.$store.dispatch("product/get", { limit: 1000 });
  },
  filters: {
    formatDate(d) {
      return moment(d).format("DD/MM/YYYY [às] HH:mm:ss");
    }
  },
  methods: {
    search(text) {
      this.filters.search = text;
      if (this.$refs.paginator) {
        this.$refs.paginator.reset();
      }
      this.dispatch();
    },
    async exportCSV() {
      if (this.exportLoading || !this.initiateCheckout.length) return;

      try {
        this.exportLoading = true;
        const CSVContent = await this.$store.dispatch(
          "sale/exportInitiateCheckout",
          clearObject({ ...this.filters, export: true })
        );
        var a = document.createElement("a");

        a.href = `data:text/csv;charset=utf-8,${CSVContent.replaceAll(
          "#",
          "%23"
        )}`;
        a.setAttribute(
          "download",
          `purchase_recovery_${moment().format(
            "YYYYMMDD"
          )}_${moment().unix()}.csv`
        );
        a.click();
      } catch (e) {
      } finally {
        this.exportLoading = false;
      }
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.dispatch();
    },
    getLink(item) {
      const queryString = new URLSearchParams(
        clearObject(item.query_params)
      ).toString();
      const product = this.products.find(p => p.id == item.product);
      const URL = `${product.url}?${queryString}`;
      return URL;
    },
    copyLink(item) {
      if (!this.product) {
        this.$message.error(
          "Selecione um produto utilizando o botão filtrar para copiar o link de checkout"
        );
        return;
      }
      const URL = this.getLink(item);
      copy(URL);
      this.$message.success("O link foi copiado!");
    },
    openLink(item) {
      if (!this.product) {
        this.$message.error(
          "Selecione um produto utilizando o botão filtrar para abrir o link de checkout"
        );
        return;
      }

      const URL = this.getLink(item);
      window.open(URL, "_blank");
    },
    dispatch() {
      const params = {
        ...this.filters,
        ...this.params
      };
      this.loading = true;
      this.$store
        .dispatch("sale/getInitiateCheckout", clearObject({ ...params }))
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    "filters.product_id"(id) {
      if (id) {
        this.$store
          .dispatch("product/getProduct", id)
          .then(data => (this.product = data));
      } else {
        this.product = "";
      }
    },
    filters() {
      this.params = {
        limit: 20,
        offset: 0
      };
      this.pagination.previous = "";
      this.$refs.paginator.reset();
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sales-recovery {
  small {
    font-size: 100%;
    font-weight: 400;
    color: rgba(59, 59, 74, 0.9);
  }
  strong {
    font-weight: 600;
  }
  ::v-deep .data-table .grid-table {
    align-items: start;
  }
  ::v-deep .font-weight-bold {
    font-weight: 500 !important;
    @media screen and (max-width: 991px) {
      color: rgba(38, 36, 50, 0.93);
    }
  }
}
</style>
